import React, { Component } from 'react';
import DateInput from '../../../sections/proposal-request/components/DateInput';

class ContractSigneeStep extends Component {
	constructor(props) {
		super(props);
		this.state = {
			memberSearch: '',
			dropdownOpen: false,
		};
		this.searchRef = React.createRef();
		this.dropdownRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (e) => {
		if (!this.state.dropdownOpen) return;

		if (
			this.dropdownRef.current &&
			!this.dropdownRef.current.contains(e.target) &&
			this.searchRef.current &&
			!this.searchRef.current.contains(e.target)
		) {
			this.setState({ dropdownOpen: false });
		}
	};

	addMember = (member) => {
		const { data, onChange } = this.props;
		const current = data.notifyTeamMembers || [];
		if (!current.includes(member._id)) {
			onChange('notifyTeamMembers', [...current, member._id]);
		}
		this.setState({ memberSearch: '', dropdownOpen: false });
	};

	removeMember = (memberId) => {
		const { data, onChange } = this.props;
		const current = data.notifyTeamMembers || [];
		onChange('notifyTeamMembers', current.filter((id) => id !== memberId));
	};


	formatPhoneNumber(cleanValue) {
		const countryRules = [
			{ code: '+1', regex: /^(\+1)(\d{3})(\d{3})(\d{4})$/, format: '$1 ($2) $3-$4' },
			{ code: '+7', regex: /^(\+7)(\d{3})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3-$4-$5' },
			{ code: '+27', regex: /^(\+27)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+30', regex: /^(\+30)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+31', regex: /^(\+31)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+32', regex: /^(\+32)(\d{3})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+33', regex: /^(\+33)(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5 $6' },
			{ code: '+34', regex: /^(\+34)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+351', regex: /^(\+351)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+352', regex: /^(\+352)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+353', regex: /^(\+353)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+354', regex: /^(\+354)(\d{3})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+356', regex: /^(\+356)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+358', regex: /^(\+358)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+36', regex: /^(\+36)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+370', regex: /^(\+370)(\d{3})(\d{2})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+371', regex: /^(\+371)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+372', regex: /^(\+372)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+385', regex: /^(\+385)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+386', regex: /^(\+386)(\d{2})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+39', regex: /^(\+39)(\d{2,3})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+40', regex: /^(\+40)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+41', regex: /^(\+41)(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+420', regex: /^(\+420)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+421', regex: /^(\+421)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+43', regex: /^(\+43)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+44', regex: /^(\+44)(\d{4})(\d{6})$/, format: '$1 $2 $3' },
			{ code: '+45', regex: /^(\+45)(\d{2})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+46', regex: /^(\+46)(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+47', regex: /^(\+47)(\d{3})(\d{2})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+48', regex: /^(\+48)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+49', regex: /^(\+49)(\d{2,4})(\d{4,8})$/, format: '$1 $2 $3' },
			{ code: '+52', regex: /^(\+52)(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+54', regex: /^(\+54)(\d{1})(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+55', regex: /^(\+55)(\d{2})(\d{5})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+56', regex: /^(\+56)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+57', regex: /^(\+57)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+60', regex: /^(\+60)(\d{1,2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+61', regex: /^(\+61)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+62', regex: /^(\+62)(\d{2,3})(\d{4,5})(\d{3,4})$/, format: '$1 $2 $3 $4' },
			{ code: '+63', regex: /^(\+63)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+65', regex: /^(\+65)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+81', regex: /^(\+81)(\d{2,3})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+82', regex: /^(\+82)(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+852', regex: /^(\+852)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+886', regex: /^(\+886)(\d{2})(\d{4})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+90', regex: /^(\+90)(\d{3})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+91', regex: /^(\+91)(\d{5})(\d{5})$/, format: '$1 $2 $3' },
			{ code: '+972', regex: /^(\+972)(\d{1,2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
		];

		for (const rule of countryRules) {
			if (cleanValue.startsWith(rule.code)) {
				return cleanValue.replace(rule.regex, rule.format);
			}
		}
		if (cleanValue.startsWith('+')) {
			return cleanValue.replace(/^(\+\d{1,3})(\d{1,4})(\d{3})(\d{4})$/, '$1-$2-$3-$4');
		}
		return cleanValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
	}

	render() {
		const { data, onChange, teamMembers } = this.props;
		const { memberSearch, dropdownOpen } = this.state;
		const selectedIds = data.notifyTeamMembers || [];

		const selectedMembers = (teamMembers || []).filter((m) => selectedIds.includes(m._id));

		const filteredMembers = (teamMembers || []).filter((m) => {
			if (selectedIds.includes(m._id)) return false;
			if (!memberSearch.trim()) return true;
			const q = memberSearch.toLowerCase();
			return (
				(m.firstName && m.firstName.toLowerCase().includes(q)) ||
				(m.lastName && m.lastName.toLowerCase().includes(q)) ||
				(m.emailAddress && m.emailAddress.toLowerCase().includes(q))
			);
		});

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Contract Signee</h1>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Client / Company Name <span className="rfp-required-mark">*</span></label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractCompanyName || ''}
						onChange={(e) => onChange('contractCompanyName', e.target.value)}
						placeholder="Enter client or company name"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Primary Contact Name</label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractContactName || ''}
						onChange={(e) => onChange('contractContactName', e.target.value)}
						placeholder="Full name"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contact Email</label>
					<input
						className="rfp-text-input"
						type="email"
						value={data.contractEmail || ''}
						onChange={(e) => onChange('contractEmail', e.target.value)}
						placeholder="email@company.com"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contact Phone</label>
					<input
						className="rfp-text-input"
						type="tel"
						value={data.contractPhone || ''}
						placeholder="+1 (555) 000-0000"
						onChange={(e) => {
							let cleanValue = e.target.value.replace(/[^0-9+]/g, '');
							cleanValue = this.formatPhoneNumber(cleanValue);
							onChange('contractPhone', cleanValue);
						}}
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contract Signer Location</label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractSignerLocation || ''}
						onChange={(e) => onChange('contractSignerLocation', e.target.value)}
						placeholder="Dallas, TX"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Due Date</label>
					<div className="rfp-date-input-wrap">
						<DateInput
							className="rfp-date-input"
							value={data.responseDueDate || ''}
							onChange={(val) => onChange('responseDueDate', val || '')}
						/>
						<i className="las la-calendar rfp-date-icon" />
					</div>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Decision Date</label>
					<div className="rfp-date-input-wrap">
						<DateInput
							className="rfp-date-input"
							value={data.decisionDate || ''}
							onChange={(val) => onChange('decisionDate', val || '')}
						/>
						<i className="las la-calendar rfp-date-icon" />
					</div>
					<div className="rfp-input-underline" />
				</div>
				

				{/* Team Members */}
				<h1 className="rfp-step-title rfp-section-title">Team Members</h1>
				<div className="rfp-field-group">
					<label className="rfp-field-label">Notify Team Members</label>
					<p className="rfp-field-description">
						Search and select team members to notify by email when this RFP is submitted.
					</p>

					{/* Selected member chips */}
					{selectedMembers.length > 0 && (
						<div className="rfp-member-chips">
							{selectedMembers.map((m) => (
								<span key={m._id} className="rfp-member-chip">
									<span className="rfp-member-chip-avatar">
										{m.firstName ? m.firstName.charAt(0).toUpperCase() : '?'}
									</span>
									<span className="rfp-member-chip-name">
										{m.firstName} {m.lastName}
									</span>
									<button
										type="button"
										className="rfp-member-chip-remove"
										onClick={() => this.removeMember(m._id)}
									>
										<i className="las la-times" />
									</button>
								</span>
							))}
						</div>
					)}

					{/* Search input + dropdown */}
					<div className="rfp-member-search-wrap" ref={this.dropdownRef}>
						<div className="rfp-member-search-input-row" ref={this.searchRef}>
							<i className="las la-search rfp-member-search-icon" />
							<input
								className="rfp-member-search-input"
								type="text"
								value={memberSearch}
								placeholder="Search by name or email..."
								onChange={(e) => this.setState({ memberSearch: e.target.value, dropdownOpen: true })}
								onFocus={() => this.setState({ dropdownOpen: true })}
							/>
						</div>

						{dropdownOpen && filteredMembers.length > 0 && (
							<div className="rfp-member-dropdown">
								{filteredMembers.slice(0, 8).map((m) => (
									<div
										key={m._id}
										className="rfp-member-dropdown-item"
										onMouseDown={() => this.addMember(m)}
									>
										<div className="rfp-member-avatar-sm">
											{m.firstName ? m.firstName.charAt(0).toUpperCase() : '?'}
										</div>
										<div className="rfp-member-info">
											<span className="rfp-member-name">
												{m.firstName} {m.lastName}
											</span>
											<span className="rfp-member-email">{m.emailAddress}</span>
										</div>
									</div>
								))}
							</div>
						)}

						{dropdownOpen && memberSearch.trim() && filteredMembers.length === 0 && (
							<div className="rfp-member-dropdown">
								<div className="rfp-member-dropdown-empty">No members found.</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default ContractSigneeStep;
